export enum AppRouteNamesList {
	settings = 'settings',
	surveyTracking = 'survey_tracking',
	roundScheduling = 'round_scheduling',

	partners = 'partners',
	partner = 'partner',
	partnersNew = 'partners_new',
	partnersEdit = 'partners_edit',
	partnersDetails = 'partners_details',

	clients = 'clients',
	clientsNew = 'clients_new',
	clientsEdit = 'clients_edit',
	clientsDetails = 'clients_details',

	templates = 'templates',
	templatesNew = 'templates_new',
	templatesEdit = 'templates_edit',
	templateScheduling = 'template_scheduling',
	surveyScheduling = 'survey_scheduling',
	emailsEdit = 'emails_edit',

	result = 'results',
	dashboard = 'dashboard',
	resultSummary = 'result_summary',
	commentPage = 'comment_page',
	personasPage = 'personas_page',
	servicePage = 'service_page',

	nexus = 'nexus',

	queries = 'queries',

	//	SURVEY MODULE
	survey = 'survey',
	module1 = 'module_1',
	module2 = 'module_2',
	module3 = 'module_3',
	finish = 'finish',

	users = 'users',
}
